import React from 'react';
import {
  Box,
  IconButton,
  useDisclosure,
} from '@chakra-ui/react';
import { FiPlus } from 'react-icons/fi';
import NodeTypeSelector from './NodeTypeSelector';
import { useCampaignContext } from './CampaignContext';

export default function AddNodeButton({ afterIndex, branch = 'true', parentIfElseId = null }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { addNode } = useCampaignContext();

  const handleSelect = (subType) => {
    addNode(subType, afterIndex, { branch, parentIfElseId });
    onClose();
  };

  return (
    <Box textAlign="center" py={1}>
      <IconButton
        icon={<FiPlus />}
        size="sm"
        borderRadius="full"
        colorScheme={branch === 'false' ? 'red' : 'brand'}
        variant="outline"
        aria-label={branch === 'false' ? 'Add to false path' : 'Add step'}
        onClick={onOpen}
        data-tour="builder-add-node"
      />
      <NodeTypeSelector isOpen={isOpen} onClose={onClose} onSelect={handleSelect} />
    </Box>
  );
}
